import React, { useEffect } from "react";
import { useAuthStore } from "../store/authStore";
import { useCrewStore } from "../store/crewStore";
import { useProfileStore } from "../store/profileStore";
import { useNotificationStore } from "../store/notificationStore";
import LoginScreen from "./auth/LoginScreen";
import AdminDashboard from "./admin/AdminDashboard";
import CrewPortal from "./crew/CrewPortal";
import Toast from "./shared/Toast";

const App: React.FC = () => {
  const { role, ready, boot, firebaseUser } = useAuthStore();
  const startCrewSync = useCrewStore((s) => s.startSync);
  const startProfileSync = useProfileStore((s) => s.startSync);
  const startNotifSync = useNotificationStore((s) => s.startSync);

  useEffect(() => {
    boot();
  }, []);

  // ── Crews + Profiles sync starts IMMEDIATELY on mount ──────────
  // crews and profiles are publicly readable (.read: true in rules)
  // so we don't need to wait for auth — this is what allows the
  // login screen to verify name+DOB on any phone without signing in first
  useEffect(() => {
    const stopCrews = startCrewSync();
    const stopProfiles = startProfileSync();
    return () => {
      stopCrews();
      stopProfiles();
    };
  }, []); // ← no dependencies — runs once on mount, stays running

  // ── Notifications sync only for authenticated admins ───────────
  useEffect(() => {
    if (role !== "admin" || !firebaseUser) return;
    const stopNotifs = startNotifSync();
    return () => stopNotifs();
  }, [role, firebaseUser]);

  if (!ready)
    return (
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "#0b0c0e",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            color: "#454850",
            fontFamily: "'Barlow',sans-serif",
            fontSize: 13,
          }}
        >
          Loading…
        </div>
      </div>
    );

  if (!role)
    return (
      <>
        <LoginScreen />
        <Toast />
      </>
    );
  if (role === "admin")
    return (
      <>
        <AdminDashboard />
        <Toast />
      </>
    );
  if (role === "crew")
    return (
      <>
        <CrewPortal />
        <Toast />
      </>
    );
  return null;
};

export default App;
